import templateUrl from './checkbox-field.html';

function frmCheckboxField() {
  return {
    restrict: 'A',
    scope: {
      model: '=',
      disabled: '=',
      checked: '=',
      required: '&'
    },
    transclude: true,
    templateUrl: templateUrl
  };
}

export default frmCheckboxField;



/** WEBPACK FOOTER **
 ** ./src/app/forms/fields/checkbox-field.directive.js
 **/